
import { Form } from 'react-bootstrap';
import { useFormContext, Controller } from 'react-hook-form';


export default function RHFDatePicker({ name, label, helperText, required, InputProps, ...other }) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <>
                    <Form.Label htmlFor={name} className="form-label">{label}{required && <span className="text-danger">*</span>}</Form.Label>
                    <Form.Control type="date" className={`form-control  ${error?.message && 'is-invalid'}`} id={name} {...field} {...other} {...InputProps} />

                    <div className="invalid-feedback">{error?.message}</div>



                </>
            )}
        />
    );
}



{/* <Form.Group>
    <Form.Label>Manufacture Date</Form.Label>
    <Form.Control type="date" id="exampleInputdate" />
</Form.Group> */}